<template>
  <div class="text-center py-12">
    <div class="text-gray-500 mb-4">
      <Icon name="heroicons:magnifying-glass" class="w-12 h-12 mx-auto mb-4" />
      <h3 class="text-lg font-medium">No events found</h3>
      <p class="text-sm mt-2">
        {{ activeFilters.length ? "Try adjusting your filters" : "No events available at the moment" }}
      </p>
    </div>
    <button
      v-if="activeFilters.length"
      @click="$emit('resetFilters')"
      class="inline-flex items-center px-4 py-2 text-sm font-medium text-primary bg-primary/10 rounded-lg hover:bg-primary/20 transition-colors"
    >
      <Icon name="heroicons:arrow-path" class="w-4 h-4 mr-2" />
      Reset Filters
    </button>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  activeFilters: string[];
}>();
</script>